import { Component } from '@angular/core';

import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'app-nin-verification-prompt',
    templateUrl: './nin-verification-prompt.component.html',
    styleUrls: ['./nin-verification-prompt.component.scss'],
    imports: []
})
export class NinVerificationPromptComponent {
  constructor(public modal: NgbActiveModal) {}

  onVerifyNow() {
    this.modal.close('verify');
  }
}
